import React from 'react'
import NiceModal, { useModal } from '@ebay/nice-modal-react'
import { createMVPModal } from '../Modal'
import WalletAddFundsModal from '../WalletAddFundsModal/WalletAddFundsModal'
import { useActiveUser } from '../../../state/hooks/ActiveUserHooks'
import { WalletDepositBonusInfoModalView } from './WalletDepositBonusInfoModalView'

class WalletDepositBonusInfoModal
{
	Show() 
	{
		NiceModal.show(createMVPModal('wallet-deposit-bonus-info-modal', () =>
		{
			const modal = useModal()
			const { depositBonus } = useActiveUser()!.config
		
			const clickDeposit = () => {
				modal.hide()
				WalletAddFundsModal.Show()
			}
		
			const handleClick = (onClick: () => void) => {
				modal.hide()
				onClick()
			}
			return <div> </div>
			// return <WalletDepositBonusInfoModalView 
			// 	depositBonus={depositBonus}

			// 	clickDeposit={() => handleClick(clickDeposit)}
			// />
		}))
	}
}

const modal = new WalletDepositBonusInfoModal()
export default modal